var render = function render(){var _vm=this,_c=_vm._self._c;return _c('form',{staticClass:"col-12 b-form b-dialog__form"},[_c('server-error',{staticClass:"mb-4",attrs:{"error":_vm.error}}),_c('CreateAssetWidget',{attrs:{"assetForm":_vm.asset},on:{"closeDialog":_vm.closeDialog,"saveAsset":function($event){return _vm.onSaveAsset($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }